const KEY = 'nagish_prefs_v1';

export interface PrefStore {
	read: () => unknown;
	write: ( value: unknown ) => void;
	clear: () => void;
	persistent: () => boolean;
}

export const createStore = (): PrefStore => {
	let memory: string | null = null;
	let ls: Storage | null = null;
	try {
		ls = window.localStorage;
		ls.setItem( '__nagish_probe', '1' );
		ls.removeItem( '__nagish_probe' );
	} catch {
		ls = null;
	}
	return {
		read() {
			try {
				const raw = ls ? ls.getItem( KEY ) : memory;
				return raw ? JSON.parse( raw ) : null;
			} catch {
				return null;
			}
		},
		write( value ) {
			const raw = JSON.stringify( value );
			memory = raw;
			if ( ls ) {
				try {
					ls.setItem( KEY, raw );
				} catch {
					ls = null;
				}
			}
		},
		clear() {
			memory = null;
			try {
				ls?.removeItem( KEY );
			} catch {
				ls = null;
			}
		},
		persistent: () => ls !== null,
	};
};

export const STORAGE_KEY = KEY;
